<script setup lang="ts">
import CarouselMobile from '../../../CarouselMobile/CarouselMobile.vue';
import IMG_MSG_INPUT from '../../assets/msg-input.png';
import IMG_STEP_INPUT from '../../assets/step-input.png';

interface Props {
  backgroundImage: string;
  productImage?: string;
  isMsgShow?: boolean;
}

withDefaults(defineProps<Props>(), {
  productImage: '',
  isMsgShow: true
});
</script>

<template>
<div class="input-message">
  <CarouselMobile
    :mobileFrameImage="IMG_STEP_INPUT"
    :backgroundImage="backgroundImage"
    :productImage="productImage"
    :msgImage="IMG_MSG_INPUT"
    :isMsgShow="isMsgShow"
    :isShowHeaderInfo="true"
  />
</div>
</template>
